<template>
    <brick-settings-base 
        v-if="show"
        v-model="newName"
        :title="resource('JourneyComposer_BrickSettingsTouchpoint_Title')"
        :canWrite="canWrite"
        :prompt="{
            title: resource('JourneyBuilder_TouchpointSettings_Delete_Title'),
            body: resource('JourneyBuilder_TouchpointSettings_Delete_Body')
        }"
        
        @save="save"
        @delete="$emit('delete')"
        @hidden="$emit('hide')"
    >

        <property :label="resource('JourneyComposer_BrickSettingsTouchpoint_ParentType_DisplayName')">
            <input-group icon="far fa-edit">
                <v-select class="form-control"

                    v-model="settings.touchpointParentType"
                    :options="touchPointParentTypes"
                    :disabled="!canWrite || touchPointParentTypes.length === 0"
                    :clearable="false"
                    
                    searchable
                    filterable
                >
                    <div slot="no-options" />
                </v-select>
                
            </input-group>
        </property>

        <property :label="resource('JourneyComposer_BrickSettingsTouchpoint_Type_DisplayName')">
            <input-group icon="far fa-edit">
                <v-select class="form-control" ref="subtype"

                    v-model="selectedTouchPointType"

                    label="name"
                    :options="availableTouchPointTypes"
                    :disabled="!canWrite || availableTouchPointTypes.length === 0"
                    :clearable="false"

                    searchable
                    filterable
                >
                    <div slot="no-options" />
                </v-select>
                
            </input-group>
        </property>

        <property :label="resource('JourneyBuilder_FilterSettings_Arrival_DisplayName')">
            {{resource('JourneyBuilder_FilterSettings_Arrival_Description')}}
            <arrival v-model="settings.arrivalCondition" :availableConditions="availableArrivalConditions"/>
        </property>

        <property :label="resource('JourneyBuilder_FilterSettings_Goal_DisplayName')">
            <toggle 
                v-model="settings.goal" 
                :sync="true" 
                :labels="{checked: resource('Bool_Yes'), unchecked: resource('Bool_No')}"
                :width="78"
            />
        </property>

        <custom-conditions v-model="settings.customConditions" :canWrite="canWrite" :parentType="settings.touchpointParentType" />

    </brick-settings-base>
</template>

<script>

import Arrival from './TouchpointArrival.vue'
import InputGroup from '../../../../../../Components/Inputs/InputGroup.vue';
import BrickSettingsBase from '../BrickSettingsBase.vue';
import CustomConditions from './TouchpointCustomConditions.vue';
import Property from '../BrickSettingsProperty.vue';

import VSelect from 'vue-select';
import { ToggleButton } from 'vue-js-toggle-button';

import {conditionTypes} from '../../../../ConnectionSettings/condition-types';
import brickSettingsMixin from '../../../../Mixins/brick-settings'
import resources from '../../../../../../Util/Mixins/resources';
import api from '../../../../api';
import { bootstrapDangerGrowl } from '../../../../../../Util/growler';
import snowplow from '../../../../snowplow';

export default {
    name: 'brick-settings-touchpoint',
    mixins: [brickSettingsMixin, resources],
    components: {
        BrickSettingsBase,
        InputGroup,
        VSelect,
        Arrival,
        Property,
        'Toggle': ToggleButton,
        CustomConditions
    },
    created() {
        const vm = this;

        api.getTouchpointTypes().then((types) => {
            vm.touchPointTypes = types;
        }, bootstrapDangerGrowl);

        api.getTouchPointParentTypes().then((types) => {
            vm.touchPointParentTypes = types;
        }, bootstrapDangerGrowl);

        //When adding new values to bjects, they are not by default reactive.
        //By setting them in this way, they are made reactive by Vue
        vm.$set(vm.settings, 'arrivalCondition', vm.settings.arrivalCondition || '');
        vm.$set(vm.settings, 'touchPointTypeId', vm.settings.touchPointTypeId || '');
        vm.$set(vm.settings, 'touchpointParentType', vm.settings.touchpointParentType || '');
        vm.$set(vm.settings, 'customConditions', vm.settings.customConditions ? vm.settings.customConditions.map((i) => Object.assign({},i)) : []);
        vm.$set(vm.settings, 'goal', vm.settings.goal || false);
    },
    methods: {
        save() {
            const touchPointType = this.touchPointTypes.find((type) => 
                type.id === this.settings.touchPointTypeId
            );

            if(touchPointType) {
                this.settings.icon = touchPointType.icon;
            }

            snowplow.trackStructuredEvent('changed-touchpoint-settings');
            this.saveSettings();
        }
    },
    computed: {
        selectedTouchPointType: {
            get(){
                const vm = this;
                return vm.touchPointTypes.find(t => t.id === this.settings.touchPointTypeId);
            },
            set(value){
                const vm = this;
                vm.settings.touchPointTypeId = value ? value.id : undefined;
            }
        },
        availableArrivalConditions() {
            const vm = this;

            //Available conditioned are filtered by parent type "Web, etc.." and condition type "arrival"
            return vm.availableConditions.filter(
                (condition) => {
                    const supportedCondition = condition.touchPointTypes.find((type) => type === vm.settings.touchPointTypeId);
                    return supportedCondition && condition.type === conditionTypes.arrival;
                }
            );
        },
        availableTouchPointTypes() {
            const vm = this;
            
            return vm.touchPointTypes.filter(
                (type) => type.parentType === vm.settings.touchpointParentType
            );
        }
    },
    watch: {
        settings: {
            handler: function (value) {
                const vm = this;
                const touchpoint = vm.touchPointTypes.find((tp) => tp.id === value.touchPointTypeId);

                //If the selected parent type no longer matches the selected touchpoint, clear selected touchpoint.
                if(touchpoint && touchpoint.parentType !== value.touchpointParentType) {
                    value.touchPointTypeId = undefined;
                    value.arrivalCondition = undefined;
                }
            },
            deep: true
        }
    },
    data() {
        return {
            touchPointTypes: [],
            touchPointParentTypes: []
        };
    }
};
</script>

<style lang="scss" scoped>

</style>